module.exports = __webpack_public_path__ + "static/whyhostimg-0cba2921bd40a5121922c275306262e8.jpg";